import axios from '@/libs/api.request'

export const login = ({ userName, password }) => {
  const data = {
    userName: userName,
    password: password,
  }
  return axios.request({
    url: '/api/login',
    data,
    method: 'post',
  })
}

export const getUserInfo = token => {
  return axios.request({
    url: '/api/get_info',
    headers: {
      Authorization: token,
    },
    method: 'get',
  })
}

export const logout = token => {
  return axios.request({
    url: 'logout',
    method: 'post',
  })
}
